<template>
  <div>
    <!-- Modal para cargar CSV -->
    <b-modal
      v-model="showModal"
      title="Importar CSV"
      size="lg"
      hide-footer
      @hidden="resetForm"
    >
      <b-form @submit.prevent="handleFileUpload">
        <!-- Campo para seleccionar archivo -->
        <b-form-file
          v-model="file"
          :state="Boolean(file)"
          placeholder="Selecciona un archivo CSV"
          accept=".csv"
          drop-placeholder="Arrastra el archivo aquí..."
          required
        ></b-form-file>

        <!-- Botón para cargar el archivo -->
        <b-button
          type="submit"
          variant="primary"
          class="mt-3"
          :disabled="!file || isLoading"
        >
          <b-spinner small v-if="isLoading"></b-spinner>
          {{ isLoading ? "Cargando..." : "Cargar" }}
        </b-button>
      </b-form>

      <!-- Tabla para previsualizar los datos -->
      <div class="table-responsive" style="max-height: 400px; overflow-y: auto;">
      <b-table
        v-if="previewData.length > 0"
        striped
        hover
        :items="previewData"
        :fields="fields"
        class="mt-3"
      ></b-table>
      </div>

      <!-- Botón para confirmar la carga -->
      <b-button
        v-if="previewData.length > 0"
        variant="success"
        class="mt-3"
        @click="confirmUpload"
        :disabled="isLoading"
      >
        Confirmar Carga
      </b-button>
    </b-modal>

    <!-- Mensaje de error -->
    <b-alert
      v-if="error"
      variant="danger"
      dismissible
      @dismissed="error = null"
    >
      {{ error }}
    </b-alert>
    <token-expired-modal :show="showTokenExpiredModal"> </token-expired-modal>
  </div>
</template>

<script>
import axios from "axios";
import TokenExpiredModal from '../components/TokenExpiredModal.vue';

export default {
  components: { TokenExpiredModal },
  data() {
    return {
      showModal: false, // Controla la visibilidad del modal
      showTokenExpiredModal: false,
      file: null, // Archivo seleccionado
      error: null, // Mensaje de error
      isLoading: false, // Indica si se está cargando el archivo
      previewData: [], // Datos para previsualizar
      fields: [], // Campos de la tabla
    };
  },
  methods: {
    // Abrir el modal
    openModal() {
      this.showModal = true;
    },

    // Cerrar el modal y resetear el formulario
    resetForm() {
      this.file = null;
      this.error = null;
      this.isLoading = false;
      this.previewData = [];
      this.fields = [];
    },

    // Manejar la carga del archivo
    async handleFileUpload() {
      if (!this.file) {
        this.error = "Por favor, selecciona un archivo CSV.";
        return;
      }

      // Validar que el archivo sea un CSV
      if (this.file.type !== "text/csv" && !this.file.name.endsWith(".csv")) {
        this.$notifications.addNotification({
          type: 'danger', // Tipo de notificación (error)
          message: 'El archivo debe ser un CSV válido.',
        });
        return;
      }

      this.isLoading = true; // Activar el indicador de carga

      const formData = new FormData();
      formData.append("file", this.file); // Añadir el archivo al FormData

      try {
        const token = localStorage.getItem("token");
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}/importar-csv`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data", // Importante para la carga de archivos
            },
          }
        );

        if (response.data.success) {
          this.previewData = response.data.data; // Guardar los datos para previsualización
          this.fields = Object.keys(this.previewData[0]); // Obtener los campos de la tabla
        } else {
          this.$notifications.addNotification({
            type: 'danger',
            message: "Error al cargar el archivo CSV."
          })
        }
      } catch (error) {
        console.error("Error en la solicitud:", error);
        this.error =
          "Error en la solicitud: " + error.message;
      } finally {
        this.isLoading = false; // Desactivar el indicador de carga
      }
    },

    // Confirmar la carga de datos
    async confirmUpload() {
      this.isLoading = true;
      try {
        const token = localStorage.getItem("token");
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}/confirmar-carga`,
          { data: this.previewData },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data.success) {
          this.$emit("csv-uploaded"); // Emitir evento para notificar la carga exitosa
          this.showModal = false;
          this.resetForm();
          this.$notifications.addNotification({
            type: 'success',
            message: "Archivo CSV cargado exitosamente."
          })
        } else {
          this.$notifications.addNotification({
            type: 'danger',
            message: "Error al confirmar la carga."
          })  
        }
      } catch (error) {
        console.error("Error en la solicitud:", error);
        this.error =
          "Error en la solicitud: " + error.message;
      } finally {
        this.isLoading = false;
      }
    },
    handleTokenExpired() {
      this.showTokenExpiredModal = true;
      setTimeout(() => {
        this.$router.push("/login");
      }, 3000);
    },
  },
};
</script>

<style scoped>
/* Estilos personalizados */
.mt-3 {
  margin-top: 1rem;
}
</style>